<h1 mat-dialog-title>{{ getDialogTitle() }}
	@if (isMultipleStlPreview()) {
		<fa-icon [icon]="faRectangleList" matTooltip="{{ getPreviewedFiles() }}" matTooltipPosition="right"></fa-icon>
	}
</h1>
<mat-dialog-content>
	<mat-drawer-container autosize>
		<mat-drawer #drawer class="sidenav" mode="over" >
			@if(isMultipleStlPreview()) {
				<form [formGroup]="webviewerSettingsForm" (ngSubmit)="updateWebviewerSettings(drawer)">
					<mat-divider></mat-divider>
					<h3>{{ 'Webviewer settings' | translate }}</h3>
					<div formArrayName="fileConfigs">
						@for (fileData of filePreviewDataAsArray; track $index) {
						<div [formGroupName]="$index">
							<div class="file-data-container">
								<strong>{{ fileData.orgFilename }}</strong>
								<div class="file-data-options-grid">
									<mat-form-field>
										<mat-label>{{ 'Jaw' | translate }}</mat-label>
										<mat-select formControlName="jaw" data-cy="jaw-select">
											<mat-option value={{WebviewerJaw.NONE}}>{{ '-' | translate }}</mat-option>
											<mat-option value={{WebviewerJaw.UPPER}}>{{ 'Upper jaw' | translate }}</mat-option>
											<mat-option value={{WebviewerJaw.LOWER}}>{{ 'Lower jaw' | translate }}</mat-option>
										</mat-select>
									</mat-form-field>
									<mat-form-field>
										<mat-label>{{ 'Type' | translate }}</mat-label>
										<mat-select formControlName="type" data-cy="kfo-type-select">
											<mat-option value={{WebviewerKfoType.JAW}}>{{ 'Jaw' | translate }}</mat-option>
											<mat-option value={{WebviewerKfoType.OVERLAY}}>{{ 'Overlay' | translate }}</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
							</div>
						</div>
						}
					</div>
					<div class="webviewer-button-container">
						<button
							mat-raised-button
							disabled="{{ webviewerSettingsForm.pristine }}"
							color="primary"
							type="submit"
							data-cy="update-webviewer-button"
						>
							{{ 'Update webviewer' | translate }}
							<mat-icon>replay</mat-icon>
						</button>
					</div>
				</form>
			}
		</mat-drawer>
		<mat-drawer-content>
		@switch (previewFileType) {
			@case (PreviewFileType.IMAGE) {
				<div class="image-container">
					<img [src]="dataUrl"/>
				</div>
			}
			@case (PreviewFileType.PDF) {
				<div class="pdf-container">
					<iframe [src]="dataUrl | safeUrl" frameborder="0"></iframe>
				</div>
			}
			@case (PreviewFileType.MODEL_3D) {
				<div class="webviewer-container">
					<iframe [src]="caWebViewerUrl" #caWebViewer [ngClass]="{
						'loading': (webviewerLoadingFinished$ | async) === null,
					}">
					</iframe>
					@if((webviewerLoadingFinished$ | async) === null) {
					<div class="loading-spinner">
						<fa-icon [icon]="faSpinner" animation="spin"></fa-icon>
					</div>
					}
				</div>
			}
			@default {
				<p>{{ 'Filetype cannot be displayed' | translate }}</p>
			}
		}
		</mat-drawer-content>
	</mat-drawer-container>
</mat-dialog-content>
<mat-dialog-actions>
	@if(isMultipleStlPreview()) {
		<button mat-raised-button (click)="drawer.toggle()">
			{{ (drawer.opened ? 'Close Settings' : 'Open Settings') | translate }}
			<mat-icon>{{drawer.opened ? 'keyboard_double_arrow_left' : 'keyboard_double_arrow_right'}}</mat-icon>
		</button>
	}@else{
		<div></div> <!-- empty div to keep the buttons aligned -->
	}
	<button mat-raised-button mat-dialog-close>{{ 'Close' | translate }}</button>
</mat-dialog-actions>
